import { render, staticRenderFns } from "./IRControllerCard.vue?vue&type=template&id=4167f2f3"
import script from "./IRControllerCard.vue?vue&type=script&lang=js"
export * from "./IRControllerCard.vue?vue&type=script&lang=js"
import style0 from "./IRControllerCard.vue?vue&type=style&index=0&id=4167f2f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports